<div class="no-access flex justify-center items-center">
  <ng-container *ngIf="isPublicAccessForbidden === false; else viewForbidden">
    <div class="no-access__img">
      <img src="/assets/images/no-access.png" alt="No Access" />
    </div>

    <h2 *ngIf="availableSpaces.length === 0" class="no-access__title">
      {{ "no-access.admin.title" | translate }}
    </h2>

    <ng-container *ngIf="availableSpaces.length > 0">
      <h2 class="no-access__title">
        {{ "no-access.avaliable-spaces.title" | translate }}
      </h2>
      <p class="no-access__subtitle">
        {{ "no-access.avaliable-spaces.subtitle" | translate }}
      </p>
      <div class="no-access__available-spaces-containe mt-2">
        <ng-container
          class="no-access__available-spaces"
          *ngFor="let space of availableSpaces; trackBy: trackByFn"
        >
          <a
            class="p-button p-component p-button-outlined p-button-primary no-access__space-button"
            [href]="'https://' + space.fullUrl"
          >
            <span
              class="mr-4"
              [ngClass]="space.spaceIcon | getIconCssClass"
            ></span>
            <span>{{ space.spaceName | propertyTranslator }}</span>
          </a>
        </ng-container>
      </div>
    </ng-container>

    <!-- <div class="no-access__subtitle">
      {{ "no-access.admin.subtitle" | translate }}
    </div> -->
    <!-- <div class="mt-8 no-access__action">
      <button pRipple class="color-primary px-12 py-4">
        {{ "no-access.admin.action" | translate }}
      </button>
    </div> -->
  </ng-container>
</div>

<ng-template #viewForbidden>
  <div class="no-access__img">
    <img src="/assets/images/none-no-access.png" alt="No Access" />
  </div>
  <h2 class="no-access__title">
    {{ "no-access.auth-user.title" | translate }}
  </h2>
  <div class="no-access__subtitle">
    {{ "no-access.auth-user.subtitle" | translate }}
  </div>
</ng-template>
